import { render, staticRenderFns } from "./assQueAnswer.vue?vue&type=template&id=f211a9c4&scoped=true"
import script from "./assQueAnswer.vue?vue&type=script&lang=js"
export * from "./assQueAnswer.vue?vue&type=script&lang=js"
import style0 from "./assQueAnswer.vue?vue&type=style&index=0&id=f211a9c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f211a9c4",
  null
  
)

export default component.exports